import { useState, useCallback, useRef, useEffect } from 'react';
import { usePrevious } from 'react-use';
import { useSpring } from 'react-spring';

export function useAccordion() {
  const [isOpen, setIsOpen] = useState(false);
  const previous = usePrevious(isOpen);
  const ref = useRef<HTMLDivElement>(null);
  const [viewHeight, setViewHeight] = useState(0);

  // Use ResizeObserver instead of useMeasure for React 19 compatibility
  useEffect(() => {
    if (!ref.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setViewHeight(entry.contentRect.height);
      }
    });

    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect();
  }, []);

  // @ts-ignore issue with types in non-beta version of react-spring
  const { height } = useSpring({
    from: { height: 0 },
    to: {
      height: isOpen ? viewHeight : 0,
    },
  });

  const toggleAccordion = useCallback(() => {
    setIsOpen((isOpen) => {
      return !isOpen;
    });
  }, []);

  return { height: isOpen && previous === isOpen ? 'auto' : height, toggleAccordion, ref, isOpen };
}